import { DayView, WeekView, AgendaView, MonthView, YearView, TimelineView, } from "./views";
export function registerViews(views) {
    const registeredViews = {};
    views.forEach(({ layout, id }) => {
        let engine;
        switch (layout) {
            case "day":
                engine = new DayView();
                break;
            case "week":
                engine = new WeekView();
                break;
            case "month":
                engine = new MonthView();
                break;
            case "year":
                engine = new YearView();
                break;
            case "agenda":
                engine = new AgendaView();
                break;
            case "timeline":
                engine = new TimelineView();
                break;
        }
        registeredViews[id] = engine;
    });
    return registeredViews;
}
export function getViewById(config, id) {
    const { views } = config;
    return views.find(({ id: vid }) => id === vid);
}
//# sourceMappingURL=registeredViews.js.map